module.exports = __webpack_public_path__ + "static/media/toggle_open_btn_icon.aff1e502.svg";